import React from 'react';
import classnames from 'classnames';
import { FieldProps } from 'formik';

import styles from './RadioField.module.scss';

interface RadioFieldOption {
  label: string;
  value: string;
}
export interface RadioFieldProps<T> extends FieldProps<T>, BasicFieldProps {
  options: RadioFieldOption[];
}
function RadioField<T extends string>({
  field,
  options,
  disabled,
  className,
}: RadioFieldProps<T>): JSX.Element {
  return (
    <ul
      className={classnames(styles.radioField, className)}
    >
      {options.map((option) => (
        <li
          key={option.value}
          className={styles.radioFieldOption}
        >
          <input
            type="radio"
            id={option.value}
            name={field.name}
            value={option.value}
            checked={option.value === field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
            disabled={disabled}
          />
          <label htmlFor={option.value}>
            {option.label}
          </label>
        </li>
      ))}
    </ul>
  );
}

export default RadioField;
